module.exports = __webpack_public_path__ + "media/Burruss Hall Part 1.f30eed73.mp3";